/** O teto de envio da KB, lido da api (spec 2026-10-21-kb-envio-grande-e-imagem, §6.4). */
import { useQuery } from '@tanstack/react-query'
import { getKbLimites } from '@/api/kb'
import { MAX_MB_PADRAO } from './envio'

/** `max_upload_mb` da api; o padrão do código enquanto a resposta não chega ou se ela falhar. */
export function useLimitesDaKb(): { maxMb: number } {
  const { data } = useQuery({ queryKey: ['kb-limites'], queryFn: getKbLimites, staleTime: 10 * 60_000 })
  return { maxMb: data?.max_upload_mb ?? MAX_MB_PADRAO }
}
